module.exports = __webpack_public_path__ + "static/media/015.d9cdffcb.jpg";